import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router'
@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {
  private subject = new Subject<any>();
  private  httpOptions = {
    headers: new HttpHeaders({'Content-Type':  'application/json'}),
  };
  constructor(private httpClient: HttpClient,private router: Router) { }

  postRequest(relativeUrl: string,data: any,params: HttpParams=null): Observable<any> {
    if(params != null){
      this.httpOptions["params"] = params;
    }
    return this.httpClient.post(environment.baseUrl+relativeUrl,data,this.httpOptions);
  }
  postRequestWithoutOptions(relativeUrl: string,data: any,httpParams: HttpParams=null): Observable<any> {
    return this.httpClient.post(environment.baseUrl+relativeUrl,data,{headers: new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    }) , params:httpParams });
  }
  public submitFormService(relativeUrl, FormData): Observable<HttpEvent<any>> {
    let httpHeaders = new HttpHeaders({});
    return this.httpClient.post<any>(environment.baseUrl+relativeUrl, FormData, { headers: httpHeaders });
  }
  getRequest(relativeUrl: string,data: HttpParams): Observable<any> {
    return  data != null ? this.httpClient.get(environment.baseUrl+relativeUrl,{ params: data }):
                            this.httpClient.get(environment.baseUrl+relativeUrl);
  }
  getImage(imageUrl: string): Observable<Blob> {
    return this.httpClient.get(imageUrl, { responseType: 'blob' });
  }
  convertToBase64(url: string) {
    return this.httpClient
    .get(url, { observe: 'response', responseType: 'blob' })
    
}
  putRequest(relativeUrl: string,data: any): Observable<any> {
    return this.httpClient.put(environment.baseUrl+relativeUrl,data);
  }

  deleteRequest(relativeUrl: string,data: any): Observable<any> {
    return this.httpClient.delete(environment.baseUrl+relativeUrl,data);
  }
  deleteById(relativeUrl: string): Observable<any> {
    return this.httpClient.delete(environment.baseUrl+relativeUrl);
  }
  uploadSign(relativeUrl: string, data: any) {
    return this.httpClient.post(environment.baseUrl + relativeUrl, data);
  }

message = 'proactiveAssist';
getGrpahtype() {
 return this.message;
}
setGrpahtype(newMessage) {
  this.message = newMessage;
}
}
